import React from "react";

export default function MigrationCTA({ onOpenModal }) {
  return (
    <section className="mt-20 bg-primary border border-primary-soft rounded-2xl p-10 text-center">
      <h2 className="text-3xl font-bold mb-4 text-white">
        Ready to Migrate Your Vector Database?
      </h2>
      <p className="text-white/70 text-lg max-w-3xl mx-auto mb-8 leading-relaxed">
        Whether you're scaling RAG pipelines, optimising costs, or avoiding vendor lock-in,
        strategic vector database migration ensures your AI infrastructure remains flexible,
        performant, and future-proof.
      </p>
      <div className="flex flex-wrap justify-center gap-4">
        <button
          onClick={onOpenModal}
          aria-label="Start vector database migration"
          className="px-8 py-3 border border-white text-white font-semibold rounded-lg hover:bg-white hover:text-primary-dark transition-all shadow-lg hover:shadow-xl"
        >
          Get Migration Tool
        </button>

        <a
          href="https://calendly.com/syed-agileforce/discovery-call"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Contact vector database migration solutions team"
          className="inline-block px-8 py-3 bg-primary-soft text-white font-semibold rounded-lg hover:bg-primary transition-all border border-primary-soft"
        >
          Contact Solutions Team
        </a>
      </div>
    </section>
  );
}